import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5c192cbe"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "step-warp"
};
const _hoisted_2 = {
  class: "add-btn"
};
const _hoisted_3 = {
  class: "table-select-warp"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 2
};
const _hoisted_7 = ["onDblclick"];
import { useI18n } from 'vue-i18n';
import { nextTick, inject, onMounted } from 'vue';
import { messageBox } from '@/utils/validate';
import { elMessage } from '@/utils';
import { AUDIT_STATUS_NEW, RELEASE_STATUS_NEW } from '@/assets/config/dicts';
import { getAddProgramInfoApi } from '@/api/vodNew';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['handle-add'],

  setup(__props, {
    expose,
    emit
  }) {
    const {
      t
    } = useI18n();
    const finishData = inject('finishData');
    const TYPE_OPTION = {
      movie: t('单片'),
      tv_series: t('剧集')
    };
    onMounted(() => {
      if (finishData.value.id && finishData.value.isFirst) {
        finishData.value.isFirst = false;
        getAddProgramInfo();
      } else {
        tableConfig.data = finishData.value.programInfo;
      }
    });
    const tableConfig = reactive({
      currentTagtype: '',
      data: [],
      isCardBlock: false,
      //   paginationConfig: usePageConfig() as any,
      isShowHeader: false,
      showPageBar: false,
      config: {
        loading: false
      },
      oldIndex: 0
    });
    const columnConfig = reactive({
      columnList: [{
        label: '',
        prop: '',
        type: 'selection'
      }, {
        label: '影片名称',
        prop: 'name'
      }, {
        label: '类型',
        prop: 'programType',
        formatter: value => TYPE_OPTION[value]
      }, {
        label: '上线状态',
        prop: 'releaseStatus',
        cellSlot: true
      }, {
        label: '审核状态',
        prop: 'auditStatus',
        cellSlot: true
      }, {
        label: '语言',
        prop: 'audioLanguage'
      }, {
        label: '排序',
        prop: 'sequence',
        cellSlot: true
      }, {
        label: '操作',
        prop: '',
        widgetType: 'buttons',
        width: 100,
        buttonsList: [{
          label: '移除',
          func: row => {
            messageBox('确定删除这条数据吗?').then(async () => {
              handleRemoveItem(row.id);
            });
          }
        }]
      }]
    }); // 获取表格列表信息

    const getAddProgramInfo = async () => {
      try {
        if (finishData.value.programInfo && finishData.value.programInfo.length > 0) {
          tableConfig.data = finishData.value.programInfo;
          return;
        }

        tableConfig.config.loading = true;
        const res = await getAddProgramInfoApi({
          videoSeriesId: finishData.value.id
        });

        if (res.code == '0') {
          tableConfig.data = res.data.map(item => {
            return { ...item,
              name: item.programName
            };
          });
          finishData.value.programInfo = res.data;
          tableConfig.config.loading = false;
        } else {
          tableConfig.config.loading = false;
        }
      } catch (error) {
        tableConfig.config.loading = false;
      }
    }; // 移除点击事件


    const handleRemoveItem = id => {
      const idx = tableConfig.data.findIndex(item => item.id === id);
      tableConfig.data.splice(idx, 1);
      tableConfig.data.forEach((item, index) => {
        item.sequence = index + 1;
      });
    };

    const selectTableConfig = reactive({
      selectData: [] // table已勾选的数据列表

    }); // table复选框点击事件

    const handleSelectionChange = val => {
      selectTableConfig.selectData = val;
    }; // 批量移除按钮点击事件


    const handleBatchRemoveClick = () => {
      if (selectTableConfig.selectData.length === 0) return elMessage('warning', '请先勾选影片');
      messageBox('是否要移除所选?').then(async () => {
        selectTableConfig.selectData.forEach(item => {
          let idx = tableConfig.data.findIndex(tableItem => tableItem.id == item.id);

          if (idx > -1) {
            tableConfig.data.splice(idx, 1);
          }
        });
        tableConfig.data.forEach((item, index) => {
          item.sequence = index + 1;
        });
      });
    };

    const editCell = ref('');

    const onEditCell = scope => {
      editCell.value = `${scope.$index}-${scope.column.no}`;
      nextTick(() => {
        const input = document.querySelector('.EL__focus .el-input__inner');
        input.focus();
      });
    }; // 修改排序输入框获取焦点事件


    const onSIndexFocus = row => {
      // 因为编辑时会改变之前的 index，所以要记住之前的 index
      tableConfig.oldIndex = row.sequence;
    };

    const onChange = (arr, code, newIndex) => {
      const oldIndex = arr.findIndex(item => item.name === code.name); // 1. move to right side:

      if (newIndex - 1 > oldIndex) {
        // console.log('right');
        let tempArr = [...arr.slice(0, oldIndex), ...arr.slice(oldIndex + 1, newIndex), code, ...arr.slice(newIndex)];
        let newArr = tempArr.map((item, index) => {
          return { ...item,
            sequence: index + 1
          };
        });
        let item = newArr.find(item => item.name === code.name);
        item.sequence = newIndex;
        return newArr;
      } // 2. move to left side: 
      else if (newIndex - 1 < oldIndex || newIndex - 1 == oldIndex) {
        // console.log('left');
        let tempArr = [...arr.slice(0, newIndex - 1), code, ...arr.slice(newIndex - 1, oldIndex), ...arr.slice(oldIndex + 1)];
        let newArr = tempArr.map((item, index) => {
          return { ...item,
            sequence: index + 1
          };
        });
        let item = newArr.find(item => item.name === code.name);
        item.sequence = newIndex;
        return newArr;
      } else if (newIndex === 1) {
        let cArr = JSON.parse(JSON.stringify(arr));
        cArr.splice(oldIndex, 1);
        let tempArr = [code, ...cArr];
        let newArr = tempArr.map((item, index) => {
          return { ...item,
            sequence: index + 1
          };
        });
        let item = newArr.find(item => item.name === code.name);
        item.sequence = newIndex;
        return newArr;
      }
    }; // 修改排序输入框丢失焦点事件


    const onSIndexBlur = row => {
      let sequence = row.sequence;

      if (sequence === '' || Number(sequence) === 0) {
        row.sequence = tableConfig.oldIndex;
        editCell.value = '';
      } else if (row.sequence !== tableConfig.oldIndex) {
        tableConfig.data = onChange(tableConfig.data, row, row.sequence);
        editCell.value = '';
      } else {
        editCell.value = '';
      }
    };

    const onInput = (e, row) => {
      if (e > tableConfig.data.length) {
        row.sequence = tableConfig.data.length;
      }
    }; // 添加影片按钮点击事件


    const showSeriesFilm = () => {
      emit('handle-add');
    };

    expose({
      tableConfig
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_input = _resolveComponent("el-input");

      const _component_column = _resolveComponent("column");

      const _component_common_table = _resolveComponent("common-table");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
        class: "cms-op-btn cms-op-btn-main",
        onClick: showSeriesFilm
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('添加')), 1)]),
        _: 1
      }), _createVNode(_component_el_button, {
        disabled: selectTableConfig.selectData.length === 0,
        style: {
          "min-width": "120px"
        },
        onClick: handleBatchRemoveClick,
        type: "danger"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('批量移除')), 1)]),
        _: 1
      }, 8, ["disabled"])]), _createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createBlock(_component_common_table, {
        ref: "tableRef",
        style: {
          "width": "100%"
        },
        "table-config": tableConfig,
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [_createVNode(_component_column, {
          "column-list": columnConfig.columnList
        }, {
          cellSlot: _withCtx(scope => [scope.column.property === 'releaseStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(RELEASE_STATUS_NEW)[scope.row.releaseStatus]), 1)) : _createCommentVNode("", true), scope.column.property === 'auditStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(AUDIT_STATUS_NEW)[scope.row.auditStatus]), 1)) : _createCommentVNode("", true), scope.column.property === 'sequence' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [editCell.value != `${scope.$index}-${scope.column.no}` ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "pointer",
            style: {
              "display": "inline-block",
              "width": "100%"
            },
            onDblclick: $event => onEditCell(scope)
          }, _toDisplayString(scope.row.sequence), 41, _hoisted_7)) : (_openBlock(), _createBlock(_component_el_input, {
            key: 1,
            oninput: "value=value.replace(/[^\\d]/g,'')",
            maxlength: "6",
            type: "number",
            class: "EL__focus",
            modelValue: scope.row.sequence,
            "onUpdate:modelValue": $event => scope.row.sequence = $event,
            modelModifiers: {
              number: true
            },
            placeholder: _unref(t)('请输入序号'),
            onFocus: $event => onSIndexFocus(scope.row),
            onBlur: $event => onSIndexBlur(scope.row),
            onInput: e => onInput(e, scope.row)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onFocus", "onBlur", "onInput"]))])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["column-list"])]),
        _: 1
      }, 8, ["table-config"])), [[_directive_loading, tableConfig.config.loading]])])]);
    };
  }

});